import {h, Fragment} from "preact"
import { useFacets, useProductFilters } from "@nosto/preact";
import Facet from "./Facet";
import RangeFacet from "./RangeFacet";
import Icon from "./elements/Icon";
import SortDropdown from "./elements/SortDropdown"



function ToggleSidebarButton({ className, isClicked, setIsClicked }) {
  return (
    // ns-d-md-none ns-absolute
    <label
      className={`ns-act-btn ns-close-sidebar ns-d-block ns-text-align-right ns-align-items-center ns-clickable ns-font-3 ${className}`}
      for="toggle-mobile-sidebar" onClick={()=>setIsClicked(false)}
    >
      <Icon name="close" />
    </label>
  );
}

export default function SideBar({ toggleId, isClicked, setIsClicked, isMobile }) {
  const { loading, facets } = useFacets();
  const { filters, removeAll } = useProductFilters()

  // console.log(facets);

  return facets?.length > 0 ? (
    <>
      {/* <input
        type="checkbox"
        id={toggleId}
        class="ns-facet-sidebar-toggle ns-d-none"
      />
      */}
      <label
        class={`ns-sidebar-backdrop ns-fixed ns-w-100 ns-h-100 ns-background-black ${isClicked ? "ns-d-block" : "ns-d-none"}`}
        for="toggle-mobile-sidebar"
        onClick={()=>setIsClicked(false)}
      /> 
      <div class="collection-filters__filter-icon">
                <button type="button" class="filter-btn" onClick={()=>setIsClicked(true)}>
                    <div class="flex gap-8">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="graphics-symbol" focusable="false">
                            <title>Filter</title>
                            <g id="Icons / Medium / Filter">
                                <g id="Group 1921">
                                    <g id="Group 1919">
                                        <circle id="Ellipse 54" cx="8" cy="9" r="2.25" stroke="#262626" stroke-width="1"></circle>
                                        <line id="Line 138" x1="2" y1="9.25" x2="6" y2="9.25" stroke="#262626" stroke-width="1"></line>
                                        <line id="Line 139" x1="10" y1="9.25" x2="22" y2="9.25" stroke="#262626" stroke-width="1"></line>
                                    </g>
                                    <g id="Group 1920">
                                        <circle id="Ellipse 54_2" cx="3" cy="3" r="2.25" transform="matrix(-1 0 0 1 19 13)" stroke="#262626" stroke-width="1"></circle>
                                        <line id="Line 138_2" y1="-0.75" x2="4" y2="-0.75" transform="matrix(-1 8.74228e-08 8.74228e-08 1 22 17)" stroke="#262626" stroke-width="1"></line>
                                        <line id="Line 139_2" y1="-0.75" x2="12" y2="-0.75" transform="matrix(-1 -8.74228e-08 -8.74228e-08 1 14 17)" stroke="#262626" stroke-width="1"></line>
                                    </g>
                                </g>
                            </g>
                        </svg>
                        <span class="filter--text custom" onClick={()=>setIsClicked(true)}>{isMobile ? "Filter and Sort" : "Filter"}</span>
                    </div>
                </button>
            </div>
      {/* ns-d-none ns-d-md-block ns-h-100 ns-col-3 ns-col-l-2 */}
      <div
        class={`ns-sidebar-wrapper ${isClicked ? "" : "ns-d-none"}`}
        // style={loading ? "opacity: 0.3;" : ""}
      >
         {/* ns-background-white ns-h-100 ns-mr-md-auto*/}
        <div class="ns-sidebar-content ns-relative ns-mr-0">
        {/* ns-align-items-baseline ns-p-4 */}
          <div class="ns-sidebar-header ns-d-flex">
            {/* <span class="ns-font-medium ns-font-5 ns-color-black"> */}
              <div class="ns-font-medium ns-font-5 ns-color-black collection-filters__heading">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  role="graphics-symbol"
                  focusable="false"
                >
                  <title>Filter</title>
                  <g id="Icons / Medium / Filter">
                    <g id="Group 1921">
                      <g id="Group 1919">
                        <circle
                          id="Ellipse 54"
                          cx="8"
                          cy="9"
                          r="2.25"
                          stroke="#262626"
                          stroke-width="1"
                        ></circle>
                        <line
                          id="Line 138"
                          x1="2"
                          y1="9.25"
                          x2="6"
                          y2="9.25"
                          stroke="#262626"
                          stroke-width="1"
                        ></line>
                        <line
                          id="Line 139"
                          x1="10"
                          y1="9.25"
                          x2="22"
                          y2="9.25"
                          stroke="#262626"
                          stroke-width="1"
                        ></line>
                      </g>
                      <g id="Group 1920">
                        <circle
                          id="Ellipse 54_2"
                          cx="3"
                          cy="3"
                          r="2.25"
                          transform="matrix(-1 0 0 1 19 13)"
                          stroke="#262626"
                          stroke-width="1"
                        ></circle>
                        <line
                          id="Line 138_2"
                          y1="-0.75"
                          x2="4"
                          y2="-0.75"
                          transform="matrix(-1 8.74228e-08 8.74228e-08 1 22 17)"
                          stroke="#262626"
                          stroke-width="1"
                        ></line>
                        <line
                          id="Line 139_2"
                          y1="-0.75"
                          x2="12"
                          y2="-0.75"
                          transform="matrix(-1 -8.74228e-08 -8.74228e-08 1 14 17)"
                          stroke="#262626"
                          stroke-width="1"
                        ></line>
                      </g>
                    </g>
                  </g>
                </svg>
                <h2 class="h6 ml-5 mb-0">Filter and Sort</h2>
              </div>
            {/* </span> */}
            <ToggleSidebarButton isClicked={isClicked} setIsClicked={setIsClicked} />
          </div>
          {!isMobile && <SortDropdown />}
          <div class="ns-sidebar-menu">
            <ul class="ns-list-unstyled ns-p-0 ns-m-0">
              {facets?.map((facet) => {
                switch (facet.type) {
                  case "terms":
                    return <Facet facet={facet} key={facet?.id}/>;
                  case "stats":
                    return <RangeFacet facet={facet} key={facet?.id}/>;
                  default:
                    return null;
                }
              })}
            </ul>
          </div>
        {isMobile && <SortDropdown/>}
        </div>
        <div class="collection-filters__submit flex justify-between items-center section-padding-small ns-bottom-submit-container">
          <a href="javascript:void(0)" class="active-filters__clear" onClick={() => {
                      removeAll()
                  }}>clear all</a>
          <div class="filter-group__apply">
          {/* form="collection-filters__form" type="submit"  */}
              <input value="Apply" class="active-filters__submit button button--primary ns-apply-filters-btn" onClick={()=>setIsClicked(false)}/>
          </div>
        </div>
      </div>
    </>
  ) : (
    ""
  );
}


